export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`${import.meta.env.HOMEPAGE}service-worker.js`)
        .catch(error => {
          // eslint-disable-next-line
          console.error('Error during service worker registration:', error);
        });
    });
  }
}
